export enum RegistrationFormStatus {
  /// <summary>
  /// U tijeku prvi potpis - Sustav je generirao upisnicu i poslao na potpis prvom roditelju/skrbniku
  /// </summary>
  FirstSignatureInProgress = 1,
  /// <summary>
  /// Jedan potpis - Prvi roditelj/skrbnik je potpisao upisnicu
  /// </summary>
  OneSignature = 2,
  /// <summary>
  /// U tijeku drugi potpis - Administrator škole je poslao upisnicu na potpis drugom roditelju/skrbniku
  /// </summary>
  SecondSignatureInProgress = 3,
  /// <summary>
  /// Dva potpisa - Drugi roditelj/skrbnik je potpisao upisnicu
  /// </summary>
  TwoSignatures = 4,
  /// <summary>
  /// Jedan potpis - Prvi roditelj/skrbnik je digitalno potpisao upisnicu
  /// </summary>
  OneSignatureDigitalConfirmation = 5,
  // This is a virtual status to indicate we are finished.
  AllSignatures = 6,
}
